<template>
  <div class="content">
    <div class="content-text">
      <h3 class="content-title">是否允许配件企业电话联系我</h3>
      <small class="content-small">选择不允许，下载记录内将隐藏您的电话信息，保障隐私</small>
    </div>
    <el-checkbox
      class="show-phone"
      :indeterminate="checkIsShowPhone == 0"
      :value="checkIsShowPhone"
      @change="showPhoneChange"
    >
      {{checkIsShowPhone == undefined ? "未设置" : (checkIsShowPhone ? "允许":"不允许")}}
    </el-checkbox>
  </div>
</template>

<script>
import {Message} from 'element-ui';
import {ApiService} from '@/libs'
import {UserService, DataService} from '@/service'

export default {
  data() {
    return {
      isShowPhone: UserService.isShowPhone(),
      isVip: UserService.isSVip(),
    }
  },
  computed:{
    checkIsShowPhone() {
      return Number(this.isShowPhone) === 1;
    }
  },
  methods: {
    showPhoneChange(val) {
      if (!this.isVip) {
        Message.warning("仅会员用户支持隐藏电话信息！");
        return;
      }
      DataService.post(`${ApiService.JrzzApi}/user/showphone/set?isShowPhone=${val ? 1 : 0}`).then(res => {
        this.isShowPhone = val ? 1 : 0;
        UserService.setIsShowPhone(`${this.isShowPhone}`);
      })
    },
  },
}
</script>

<style lang="less" scoped>
.content{
  display: flex;
  align-items: center;
}
.content-text {
  color: #000;
  flex: 1;
  display: flex;
  flex-flow: nowrap column;
}
.content-small {
  color: #888;
}
.show-phone {
  /deep/ .el-checkbox__input.is-indeterminate {
    /deep/ .el-checkbox__inner {
      background-color: #f33;
      border-color: #f33;
      &::before {
        content: "✕";
        position: absolute;
        display: block;
        background-color: #fff;
        height: 0px;
        transform: scale(0.5);
        left: -2px;
        right: 0;
        font-size: 21px;
        top: 1px;
        color: #fff;
      }
    }
  }
  /deep/ .el-checkbox__inner {
    background-color: #999;
    border-color: #999;
    &::after {
      width: 7px;
      height: 1px;
      left: 2px;
      top: 5px;
      right: 2px;
      background-color: #fff;
      transform: rotate(0) scaleY(1);
    }
  }

  /deep/ .el-checkbox__input.is-checked .el-checkbox__inner{
    background-color: #409EFF;
    border-color: #409EFF;
    &::after {
      content: "";
      border: 1px solid #fff;
      background-color: transparent;
      border-left: 0;
      border-top: 0;
      width: 3px;
      height: 7px;
      left: 4px;
      top: 1px;
      transform: rotate(45deg) scaleY(1);
    }
  }
}
</style>
